import { createTheme, adaptV4Theme } from '@mui/material/styles';

const scrollBackGroudColor = '#f6f8fb';//#8c95a7 //#2b2b2b

import {
    ColorIconoTabsActivas
} from '../Componentes/Tool/PaletaColores';

const theme = createTheme(
    adaptV4Theme({
        overrides: {
            MuiCssBaseline: {
                "@global": {
                    body: {
                        scrollbarColor: "#6b6b6b " + scrollBackGroudColor,
                        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                            width: 10,
                            backgroundColor: scrollBackGroudColor,
                        },
                        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                            borderRadius: 8,
                            backgroundColor: "#6b6b6b",
                            minHeight: 24,
                            border: "2px solid " + scrollBackGroudColor,
                        },
                        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                            backgroundColor: scrollBackGroudColor,
                        }
                    }
                }
            },
            //MuiButton: {
            //    '&.Mui-disabled': {
            //        color: '#A9A9A9 !important'
            //    }
            //},
            MuiTabs: {
                indicator: {
                    backgroundColor: '#283593 !important'
                }
            },
            MuiInputBase: {
                multiline: {
                    padding: '0px !important'
                }
            },
            MuiOutlinedInput: {
                input: {
                    padding: '13px 14px'
                }
            },
            MuiAutocomplete: {
                inputRoot: {
                    padding: '5px !important',
                    paddingRight: '60px !important'
                }
            },
            MuiInputLabel: {
                outlined: {
                    color: '#4A4B4C',
                    top: '-2px'
                }
            },
            MuiStepLabel: {
                label: {
                    marginTop: '0px !important',
                    '&.Mui-active': {
                        color: ColorIconoTabsActivas + ' !important'
                    },
                    '&.Mui-completed': {
                        color: ColorIconoTabsActivas + ' !important'
                    },
                }
            },
            MuiGrid: {
                container: {
                    background: '#F6F8FB',
                    scrollbarColor: "#6b6b6b " + scrollBackGroudColor,
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        width: 10,
                        backgroundColor: scrollBackGroudColor,
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: "#6b6b6b",
                        minHeight: 24,
                        border: "2px solid " + scrollBackGroudColor,
                    },
                    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                        backgroundColor: scrollBackGroudColor,
                    }
                }
            },
            MuiAppBar: {
                colorPrimary: {
                    color: '#FFFFFF',
                },
                //positionRelative: {
                //    borderBottom: "solid #33C2FF 5px"
                //}
            }//,
           // "MuiTable-root": {
           //     fontFamily: "roboto",
           //     borderCollapse: "collapse",
           //     width: "100%"
           // },
           //"MuiStyledTableCellClass-root": {
           //     border: "1px solid #E9EBEE"
           // }
        },
        palette: {
            mode: 'light',
            primary: {
                main: '#00152a',
            },
            secondary: {
                main: '#33C2FF',
            },
            background: {
                default: '#F6F8FB',
            },
            error: {
                main: '#f44336',
            },
            divider: '#E9EBEE'
        },
        typography: {
            fontSize: 16,
            h1: {
                fontWeight: 400,
                fontSize: 17,
                fontFamily: 'roboto',
                lineHeight: 1.3,
                color: '#223354'
            },
            h2: {
                fontWeight: 500,
                fontSize: 20,
                fontFamily: 'roboto',
                lineHeight: 1.1,
                color: '#FFFFFF'
            },
            h3: {
                fontWeight: 'bold',
                fontSize: 48,
                fontFamily: 'roboto',
                color: '#223354'
            },
            h4: {
                fontWeight: 'bold',
                fontSize: 34,
                fontFamily: 'roboto',
                color: '#223354'
            },
            h5: {
                fontWeight: 600,
                fontSize: 24,
                lineHeight: '24px',
                letterSpacing: '0.15px',
                fontFamily: 'roboto',
                color: '#223354'
            },
            h6: {
                fontWeight: 500,
                fontSize: 20,
                fontFamily: 'roboto',
                lineHeight: '24px',
                letterSpacing: '0.15px',
                color: '#223354'
            },
            subtitle2: {
                fontWeight: 'bold',
                fontSize: 18,
                fontFamily: 'roboto',
                lineHeight: 1,
                color: '#223354'
            },
            subtitle1: {
                fontWeight: 'bold',
                fontSize: 14,
                fontFamily: 'roboto',
                color: '#9099A9'
            },
            body1: {
                fontWeight: 400,
                fontSize: 16,
                fontFamily: 'roboto',
                color: '#223354'
            },
            body: {
                fontWeight: 400,
                fontSize: 14,
                fontFamily: 'roboto',
                lineHeight: 1,
                color: '#223354'
            }
        }
    }));

export default theme;